import React from 'react';
import img7black from '../assets/images/img7black.png'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPhone, faEnvelope } from '@fortawesome/free-solid-svg-icons';
import '../assets/css/Header.css';
import { Link } from 'react-router-dom';
import fitty from 'fitty';

const Header = () =>
    <>
        <header id='header' style={{ display: 'flex', position: 'absolute', width: '100%'}}>

            {/* <div className="left"> */}
            <Link style={{ paddingLeft: '120px', padding: '20px', textAlign: 'left', left: '0'}} className='link' to="/">
                <img width={130} src={img7black} alt="png" />
            </Link>
            {/* <h3>Signature Move Investment Group</h3> signaturemoveig@gmail.com */}
            {/* <span style={{ float: "right", position: 'relative'}} className="right">
                {/* <div>
                <FontAwesomeIcon  icon={faEnvelope} color="#cfa167" />
                <p style={{paddingRight:"8px"}}>signaturemoveig@gmail.com</p>
            </div>
                <div style={{position: 'absolute', bottom: '0'}}>
                    <FontAwesomeIcon icon={faPhone} color="#cfa167" />
                    <p>+1 410 204 4070</p>
                </div>
            </span> */}

            <div className='link' style={{right: '0'}}>
                <div className='linkContainer' style={{right: '0', display: 'inline-block', paddingTop: '40px', flexWrap: 'nowrap'}}>
                    {/* <Link className='link' to="/">Home  </Link> */}
                    <Link style={{ paddingRight: "12px", letterSpacing: "4px" }} className='link' to="/request">  Request  </Link>
                    <Link style={{ paddingRight: "12px", letterSpacing: "4px" }} className='link' to="/Contact">  Contact  </Link>
                    <Link style={{ paddingRight: "12px", letterSpacing: "4px" }} className='link' to="/About">  About  </Link>
                    <Link style={{ paddingRight: "12px", letterSpacing: "4px" }} className='link' to="/Appointment">  Appointment  </Link>
                    {/* <Link className='link' to="/Reservation">  Credits  </Link> */}
                </div>
            </div>
            <div id="bordered"></div>

        </header>
    </>
export default Header;